// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
export const $ModuleId = 'System';

export * from "../../Entity/System/UserIdAndName.js";
export * from "../../Entity/System/BinaryData.js";
export * from "../../UserDefinedConfiguration/System/UserLanguage.js";
export * from "../../Label/System/$translations.js";
export * from "../../Resource/System/$resources.js";
export * from "../../ConfigurationItem/System/config.js";
export * as $Process from "../../Process/System/$processes.js";
export * from "../../Role/System/$roles.js";
export * from "../../Permission/System/$permissions.js";
export * from "../../Screen/System/$screens.js";
